import { render, staticRenderFns } from "./BundleProductsForm.vue?vue&type=template&id=49d82bb0&"
import script from "./BundleProductsForm.vue?vue&type=script&lang=js&"
export * from "./BundleProductsForm.vue?vue&type=script&lang=js&"
import style0 from "./BundleProductsForm.vue?vue&type=style&index=0&id=49d82bb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports